export default __webpack_public_path__ + "static/media/vehicleViewPrevious.e9c59c24.svg";